"use client";

import { CaretRight } from "@phosphor-icons/react";
import { cn } from "@/shared/lib/utils";
import type { ScopeNode } from "../types";

export function Breadcrumbs({
  chain,
  onJump,
  className,
  size = "sm",
}: {
  chain: ScopeNode[];
  onJump?: (scopeId: string) => void;
  className?: string;
  size?: "sm" | "md";
}) {
  if (chain.length === 0) return null;
  const textCls = size === "md" ? "text-xs" : "text-[11px]";
  return (
    <div className={cn("flex items-center gap-1", textCls, className)}>
      {chain.map((node, i) => {
        const isLast = i === chain.length - 1;
        // Leaf gets a soft pill so it reads as proper scope context;
        // ancestors stay plain subtle.
        const baseCls = isLast
          ? "px-1.5 py-0.5 rounded-md bg-muted/60 text-foreground/80 font-medium"
          : "px-1.5 py-0.5 text-muted-foreground/70";
        return (
          <div key={node.id} className="flex items-center gap-1">
            {onJump ? (
              <button
                type="button"
                onClick={() => onJump(node.id)}
                className={cn(
                  baseCls,
                  "transition-control hover:bg-muted hover:text-foreground"
                )}
              >
                {node.shortTitle ?? node.title}
              </button>
            ) : (
              <span className={baseCls}>{node.shortTitle ?? node.title}</span>
            )}
            {!isLast && <CaretRight className="size-3 opacity-40 shrink-0" />}
          </div>
        );
      })}
    </div>
  );
}
